import type { Axios } from 'axios';
import { get, writable } from 'svelte/store';
import { apiStore } from './api';
import { businessStore } from './business';

export type ThemeColors = {
	uiPrimaryColor: string;
	uiSecondaryColor: string;
};

export const themeColorStore = writable<ThemeColors>({
	uiPrimaryColor: '#00b300',
	uiSecondaryColor: '#202620'
});

export function reloadThemeColor() {
	themeColorStore.set({
		uiPrimaryColor: get(businessStore)?.uiPrimaryColor ?? '#00b300',
		uiSecondaryColor: get(businessStore)?.uiSecondaryColor ?? '#202620'
	});
}

export const themeStore = writable<ThemeType>('system'); // 'system', 'dark', 'light'

type ThemeType = 'system' | 'dark' | 'light';

// Change theme
export function setTheme(newTheme: ThemeType) {
	themeStore.set(newTheme);
	localStorage.setItem('theme', newTheme);
	if (newTheme === 'dark') {
		document.body.classList.add('dark');
	} else if (newTheme === 'light') {
		document.body.classList.remove('dark');
	} else {
		document.body.classList.toggle(
			'dark',
			window.matchMedia('(prefers-color-scheme: dark)').matches
		);
	}
}

export function saveUiColors(primary: string, secondary: string): Promise<void> {
	return (get(apiStore) as Axios).post('/business/ui', {
		primaryColor: primary,
		secondaryColor: secondary
	});
}
